import { render } from "./StorySlideWrapper.vue?vue&type=template&id=0b3bfd1c"
import script from "./StorySlideWrapper.vue?vue&type=script&lang=js"
export * from "./StorySlideWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__